import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { InstanceService } from '../services/instance.service';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SessionService } from '../services/session.service';
import { defaultAppCenterUrl } from '../../../environments/environment';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private sessionService: SessionService,
        private router: Router,
        private cookieService: CookieService,
        private instanceService: InstanceService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {

        if (!this.cookieService.check("app-center-sessionId")) return this.redirectToLogin()

        return this.sessionService.session$
            .pipe(
                switchMap(session => {
                    if (!session.isValid) {
                        // Session is not valid cookie can be deleted and user redirected to app-center to login again
                        this.cookieService.deleteAll();
                        return of(this.redirectToLogin())
                    };
                    if (session.hasSuperOps || session.hasSuperAdmin) return of(true);
                    // Check if app is enabled
                    if (window.location.href.includes('localhost')) {
                        return of(true);
                    }
                    return this.sessionService.apps$;
                }),
                map(apps => {
                    if (Array.isArray(apps)) {
                        let item = apps.find(item => item.url.includes(window.location.host));
                        if (item !== undefined) {
                            return true;
                        } else {
                            return this.redirectToLogin();
                        }
                    }
                    return apps;
                })
            )
    }

    redirectToLogin(): boolean {
        const appCenterUrl = this.instanceService.appCenterUrl;
        window.location.replace(appCenterUrl ?? defaultAppCenterUrl);
        return false;
    }
}
